import { render, staticRenderFns } from "./admin-visitor.vue?vue&type=template&id=3e8c5856&"
import script from "./admin-visitor.vue?vue&type=script&lang=js&"
export * from "./admin-visitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports